import BonusInclusionsLabeledContainer from 'components/Common/Labels/BonusInclusionsLabeledContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import * as React from 'react'

interface Props extends React.PropsWithChildren {
  duration?: number
  title?: 'bonus' | 'additional'
}

function AccommodationPackageInclusionsList(props: Props) {
  const {
    children,
    title,
    duration,
  } = props

  if (title === 'bonus') {
    return <BonusInclusionsLabeledContainer duration={duration}>
      <VerticalSpacer gap={4}>
        {children}
      </VerticalSpacer>
    </BonusInclusionsLabeledContainer>
  }

  return <VerticalSpacer gap={4}>
    {children}
  </VerticalSpacer>
}

export default AccommodationPackageInclusionsList
